// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__wkW9n","title":"style_title__3bS2O","editButtonWrapper":"style_editButtonWrapper__3TzLW"};